export default [
    {
        key: "forwardhead",
        name: "Protusão de cabeça",
        definition: {
            name: "Definição",
            list: ["Protusão de cabeça (ou cabeça projetada para frente) é uma alteração postural em que a cabeça fica mais à frente do que o alinhamento ideal da coluna cervical e torácica. É quando em posição em pé ou sentado, o queixo e a cabeça avançam para frente, aumentando a carga sobre a coluna cervical."]
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1、Trabalhar curvado por muito tempo. Quando se trabalha diante do computador por um longo tempo, a cabeça se inclina para a frente habitualmente.",
                "2、Habitualmente abaixar a cabeça para olhar o celular. Olhar para o celular com a cabeça baixa, ou seja, a chamada ‘tribo dos que abaixam a cabeça’, também é a principal causa indutora da proeminência da cabeça.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1、Tontura e dor de cabeça: A proeminência da cabeça pode afetar a circulação sanguínea na cabeça. Devido à má circulação sanguínea, ocorre falta de oxigênio na cabeça, causando tontura e dor de cabeça.",
                "2、Cervicalgia: Devido à posição anormal da cabeça, ocorrem anormalidades nos tecidos moles e ossos do pescoço, aumentando o risco de doenças cervicais.",
                "3. Doenças cardiovasculares e cerebrovasculares: A posição anormal da cabeça pode afetar a circulação sanguínea na cabeça e prejudicar a saúde cardiovascular e cerebrovascular.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "Inclinação lateral da cabeça",
        definition: {
            name: "Definição",
            list: ["Inclinação lateral da cabeça refere-se à postura anormal em que a cabeça se inclina excessivamente para um lado quando o corpo humano está na posição natural de pé ou sentado. A principal causa é o desequilíbrio da força muscular do pescoço e dos ombros dos dois lados, geralmente causado por posturas erradas habituais."]
        },
        triggerreason: {
            name: "Causas",
            list: [
                "1、Habitualmente usar os músculos do pescoço e do ombro de um lado: Quando sentado ou deitado, o pescoço geralmente se inclina apenas para um lado, causando desequilíbrio na força muscular do pescoço e dos ombros dos dois lados.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Desgaste crônico dos músculos e ligamentos: A inclinação lateral da cabeça por um longo tempo pode facilmente levar ao desgaste crônico dos ligamentos posteriores do pescoço e dos ligamentos e músculos.",
                "2. Cervicalgia: Devido à posição anormal da cabeça, ocorrem anormalidades nos tecidos moles e ossos do pescoço, aumentando o risco de doenças cervicais.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "Ombreos desalinhados",
        definition: {
            name: "Definição",
            list: ["Ombreos desalinhados refere-se à situação em que os ombros dos dois lados têm alturas verticais diferentes quando o corpo humano está em estado natural de relaxamento. Geralmente, os ombros desiguais acompanham anormalidades na postura da coluna vertebral."]
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Força excessiva em um lado: por exemplo, carregar mochila ou objetos pesados em um lado por um longo tempo.",
                "2. Postura incorreta por um longo tempo: Causada por más hábitos como cruzar as pernas e sentar por muito tempo, ou inclinar-se sobre a mesa ao trabalhar curvado.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Dor nas costas: (ombros desiguais) podem causar deslocamento da pélvis, fazendo com que a força muscular dos dois lados da cintura fique desequilibrada e causando dor nas costas.",
                "2. Osteófito: Os ombros desiguais fazem com que a força na coluna cervical seja anormal e, finalmente, podem levar à degeneração da região da coluna cervical e facilmente formar osteófitos.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "Protusão de ombros",
        definition: {
            name: "Definição",
            list: ["Protusão de ombros refere-se ao estado em que os ombros aparecem curvados para frente e para dentro quando observados lateralmente. Geralmente acompanhado de cifose. É comum em estudantes e pessoas que trabalham em escritórios."],
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Má postura habitual: como ombros curvados e corcunda, deitar de lado de forma irregular etc.",
                "2. Desequilíbrio muscular no peito e nas costas: Os músculos peitorais são relativamente fracos em comparação com os músculos das costas.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Maior carga no coração: Ombro arredondado excessivo fará com que o diafragma fique tenso, causando compressão da aorta e da veia cava, aumentando a carga de trabalho do coração.",
                "2. Nervos comprimidos: A tensão muscular ao redor dos ombros e do pescoço pode, em casos graves, comprimir os nervos cervicais, causando dor de cabeça e dormência no braço.",
            ],
        }
    },
    {
        key: "scoliosis",
        name: "escoliose vertebral",
        definition: {
            name: "Definição",
            list: ["Ocorrem anormalidades na posição da coluna vertebral. Através de exames de imagem, pode-se detectar estados não retos da coluna vertebral, como escoliose vertebral. As anormalidades podem ser divididas em congênitas e adquiridas. As anormalidades adquiridas estão relacionadas a erros habituais de postura."],
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Excesso de força unilateral: por exemplo, carregar mochila ou objetos pesados unilateralmente por um longo tempo.",
                "2. Postura incorreta por muito tempo: causada por maus hábitos como cruzar as pernas e ficar sentado por muito tempo, ou inclinar-se sobre a mesa ao trabalhar curvado.",
                "3. Causas congênitas: Escoliose vertebral causada por fatores congênitos.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Hérnia de disco lombar.",
                "2. Dor nas costas: Pode causar deslocamento da pélvis, tornando a força muscular dos dois lados da cintura desequilibrada e resultando em dor nas costas.",
                "3. Pernas de comprimentos diferentes.",
            ],
        }
    },
    {
        key: "unevenhip",
        name: "inclinção lateral da pélvis",
        definition: {
            name: "Definição",
            list: ["A inclinação lateral da pélvis refere-se ao estado em que a altura dos quadris dos dois lados é bastante diferente, apresentando um estado de inclinação da pélvis. Muitas vezes acompanhado por anormalidades na posição da coluna vertebral e ombros desiguais."],
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Postura incorreta por muito tempo: causada por maus hábitos como cruzar as pernas e ficar sentado por muito tempo, ou inclinar-se sobre a mesa ao trabalhar curvado.",
                "2. Pernas de comprimentos diferentes congênitas: Inclinção lateral da pélvis causada por pernas de comprimentos diferentes congênitas.",
                "3. Desequilíbrio postural dos membros inferiores dos dois lados: por exemplo, um pé tem pé chato enquanto o outro não tem, ou o grau é diferente; ambos os lados têm hiper-extensão do joelho, mas o grau é diferente.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Hérnia de disco lombar.",
                "2. Dor crônica: A inclinação lateral da pélvis pode causar dor nas pernas e cintura, bem como dor no pescoço e ombros.",
                "3. Pernas de comprimentos diferentes.",
            ],
        }
    },
    {
        key: "oleg",
        name: "Geno varo",
        definition: {
            name: "Definição",
            list: ["Alinhamento em que o ângulo femorotibial medial aumenta e o lateral diminui, produzindo adução tibial relativa e distribuição aumentada de carga no compartimento medial."],
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Hábitos posturais ruins, como: inclinação posterior da pélvis e tendência à pronação do pé.",
                "2. Desequilíbrio de força muscular, como: músculos rotadores externos do quadril muito apertados.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Lesão do menisco medial: As pernas em forma de O causam mudanças na linha de força das extremidades inferiores. O espaço medial do joelho suporta pressão maior do que a carga normal. Pode causar lesão do menisco medial do joelho.",
                "2. Artrite: Casos graves (pernas em forma de O) podem eventualmente se desenvolver em osteoartrite do joelho e degeneração articular no espaço articular lateral. Em casos graves, pode ser necessário realizar uma cirurgia de substituição de articulação artificial.",
            ],
        }
    },
    {
        key: "xleg",
        name: "Geno Valgo",
        definition: {
            name: "Definição",
            list: "Alinhamento em que o ângulo femorotibial medial diminui e o lateral aumenta, resultando em adução do fêmur e abdução da tíbia. A carga mecânica desloca-se para o compartimento lateral do joelho.",
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Maus hábitos posturais, como: inclinação pélvica anterior, tendência à eversão do pé.",
                "2. Desequilíbrio muscular, como: músculos de rotação interna do quadril muito apertados.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Lesão do menisco lateral: As pernas em forma de X causam mudanças na linha de força das extremidades inferiores. O espaço lateral do joelho suporta pressão maior do que a carga normal. Pode causar lesão do menisco lateral do joelho.",
                "2. Artrite: Casos graves (pernas em forma de X) podem eventualmente se desenvolver em osteoartrite do joelho e degeneração articular no espaço articular lateral. Em casos graves, pode ser necessário realizar uma cirurgia de substituição de articulação artificial.",
            ],
        }
    },
    {
        key: "kneehyperextension",
        name: "Hiperextensão dos joelhos",
        definition: {
            name: "Definição",
            list: ["Hiperextensão dos joelhos, também conhecida como 'arco reverso do joelho'. Do lado do corpo humano, pode-se ver que a perna se curva para trás, o joelho se cava para dentro e a panturrilha se estende excessivamente à frente em comparação com a coxa. Este tipo de postura é comum em bailarinas e pessoas com fraqueza muscular na coxa."],
        },
        triggerreason: {
            name: "As causas",
            list: [
                "1. Postura incorreta de aplicação de força: ao ficar em pé, o peso principal cai na parte da frente do pé.",
                "2. Tensão na fáscia plantar: Pode ser causada pelo uso prolongado de sapatos de salto alto.",
                "3. Fraqueza muscular ao redor do joelho. Insuficiência de força muscular na parte anterior e posterior da coxa.",
            ]
        },
        danger: {
            name: "Riscos",
            list: [
                "1. Deformidade do joelho: A hiperextensão do joelho a longo prazo pode levar a um aumento significativo na incidência de degeneração osteoarticular e causar desgaste excessivo do joelho, resultando em deformidade articular.",
                "2. Danos ao equilíbrio geral: Existe uma grande conexão posicional e funcional entre as três articulações do quadril, joelho e tornozelo. A mudança na posição do joelho afetará a posição do tornozelo abaixo e a posição do quadril e da pelve acima, gradualmente prejudicando o equilíbrio geral do corpo. A longo prazo, isso pode causar vários tipos de dor.",
            ],
        }
    },
]